import { Transplier } from './base'

export class PythonTranspiler extends Transplier {
  name = 'python'

  transpile(): string {
    return '# NOT IMPLEMENTED'
  }
}
